import loginReducer from './reducer';
import * as actionsModule from './actions';

export { default } from './LoginPage';
export const reducer = loginReducer;
export const actions = actionsModule;
